<template>
  <div>
    <a-modal :modal-id="'append-files-' + data.id">
      <div slot="title">Attach files</div>
      <div slot="form">
        <div v-if="modalFiles.length" class="row m-t-sm">
          <label>Current Files</label><br>
          <span v-for="file in modalFiles" :key="file.id" class="label label m-r-xs m-b-sm inline-block">
            <i class="fa fa-file fa-lg"></i> {{ file.name }}
          </span>
        </div>
        <div class="row m-t-sm">
          <label for="file">New Files</label>
          <input class="form-control" type="file" id="file" ref="fileInterface" multiple/>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-success btn-sm pull-right" @click="appendFiles">Add Files</button>
      </div>
    </a-modal>
    <div>
      <div class="flex-space-between">
        <span v-if="!data.files.length">No files here at the moment</span>
        <div v-else class="display-block">
          <span v-for="file in data.files" :key="file.id" class="label label m-r-xs m-t-xs inline-block">
            <a v-tooltip="'Download file'" class="m-r-xs" @click="downloadFile(file.id)">
              <i class="fa fa-file fa-lg"></i> {{ file.name }}
            </a>
            <a v-if="user.master" v-tooltip="'Delete file'" @click="deleteFile(file)"><i class="fa fa-multiply red fa-lg"></i></a>
          </span>
        </div>
        <button v-if="!uploadDisabled" class="btn btn-success btn-xs pull-right" data-toggle="modal" :data-target="'#append-files-' + data.id" @click="modalFiles = data.files || []">Add Files</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Browser } from '../../../mixins/helperMixin'

export default {
  props: {
    data: {
      required: true
    },
    type: {
      type: String,
      validator: function (value) {
        return ['tasks', 'projects', 'messages'].includes(value)
      }
    },
    uploadDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      modalFiles: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    downloadFile (id) {
      axios.get(`/v2/${this.type}/files/${id}`, { responseType: 'blob' })
        .then(r => {
          const name = r.headers['content-disposition'].split('=')[1]
          Browser.methods.downloadFile(name, r.data)
        })
        .catch(err => {
          this.$toastr.error('Failed to download file', err)
        })
    },
    async deleteFile (file) {
      try {
        if (confirm(`Are you sure you want to delete ${file.name}?`)) {
          await axios.delete(`/v2/${this.type}/files/${file.id}`)
          this.$emit('reloadData')
          this.$toastr.success(`${file.name} deleted`, 'Success')
        }
      } catch (error) {
        this.$toastr.error('Deleting file failed', error)
      }
    },
    async appendFiles () {
      try {
        if (!this.$refs.fileInterface.files.length) {
          this.$toastr.warning('Please select some files first')
          return
        }
        const formData = await this.buildFormData()
        await axios.patch(`/v2/${this.type}/${this.data.id}/files`, formData)
        this.$emit('reloadData')
        $('#append-files-' + this.data.id).modal('hide')
        this.$toastr.success('Files added', 'Success')
        this.$refs.fileInterface.value = null
      } catch (error) {
        this.$toastr('Failed to add file', error)
      }
    },
    async buildFormData () {
      const formData = new FormData()
      for (let i = 0; i < this.$refs.fileInterface.files.length; i++) {
        let file = this.$refs.fileInterface.files[i]
        formData.append(`files[${i}]`, file)
      }
      return formData
    }
  }
}
</script>
<style scoped>
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.large-font {
  font-size: large;
}
.display-block {
  display: block;
}
.inline-block {
  display: inline-block;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Helpers/Files/FileInterface.vue